import type React from "react"

import CloseIconRounded from "@mui/icons-material/CloseRounded"
import type { DialogTitleProps as MuiDialogTitleProps } from "@mui/material"
import { Box, IconButton, DialogTitle as MuiDialogTitle } from "@mui/material"

interface DialogTitleProps extends MuiDialogTitleProps {
  /**
   * provide an id for accessibility, see https://mui.com/material-ui/react-modal/#accessibility
   */
  id: string
  onClose: React.MouseEventHandler<HTMLButtonElement> | undefined
  leftActions?: React.ReactNode
  rightActions?: React.ReactNode
}

export const DialogTitle: React.FC<DialogTitleProps> = ({
  children,
  onClose,
  id,
  leftActions,
  rightActions,
  ...muiDialogTitleProps
}) => (
  <MuiDialogTitle id={id} {...muiDialogTitleProps}>
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        width: "100%",
      }}
    >
      <Box sx={{ alignItems: "center", display: "flex", gap: 1, minWidth: 0 }}>
        {children}
        <Box sx={{ alignItems: "center", display: "flex", minWidth: 0 }}>
          {leftActions}
        </Box>
      </Box>
      <Box sx={{ alignItems: "center", display: "flex", ml: "auto" }}>
        {rightActions}
        <IconButton aria-label="Close" onClick={onClose} sx={{ ml: 1 }}>
          <CloseIconRounded />
        </IconButton>
      </Box>
    </Box>
  </MuiDialogTitle>
)
